import { clstx } from '@payaca/utilities/cvaMerge';
import { motion } from 'motion/react';
import { forwardRef, PropsWithChildren } from 'react';

const MobileDevicePreview = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ className?: string }>
>((props, ref) => {
  const { className, children } = props;

  return (
    <div
      ref={ref}
      className={clstx(
        // iPhone 12 Pro dimensions
        // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- iPhone viewport size
        'border-5 border-gray-800 rounded-3xl w-[390px] h-[844px] overflow-y-auto',
        className
      )}
    >
      {children}
    </div>
  );
});

export default Object.assign(MobileDevicePreview, {
  motion: motion.create(MobileDevicePreview),
});
